import { render, staticRenderFns } from "./booksReadMobile.vue?vue&type=template&id=73e1c19a&"
import script from "./booksReadMobile.vue?vue&type=script&lang=js&"
export * from "./booksReadMobile.vue?vue&type=script&lang=js&"
import style0 from "./booksReadMobile.vue?vue&type=style&index=0&id=73e1c19a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports